export const UPDATE_FLASH_MESSAGE = 'UPDATE_FLASH_MESSAGE';
export const RESET_FLASH_MESSAGE = 'RESET_FLASH_MESSAGE';
export const ADD_SUBJECT = 'ADD_SUBJECT';
export const ADD_PLAN = 'ADD_PLAN';

// API Constants
export const CURRICULUM = 'CURRICULUM';
export const LANGUAGE = 'LANGUAGE';
export const USERS = 'USERS';
export const ORDERS = 'ORDERS';
export const PROFILE = 'PROFILE';
export const PRODUCTS = 'PRODUCTS';
export const PRODUCT_EVENT = 'PRODUCT_EVENT';
export const SHORTURL = 'SHORTURL';
export const ORGANIZATIONS = 'ORGANIZATIONS';
export const RESPONSE = 'RESPONSE';
export const PAYMENT = 'PAYMENT';
export const SIGNEDURL = 'SIGNEDURL';
export const SEO_CONTENT = 'SEO_CONTENT';
export const QUESTIONNAIRE = 'QUESTIONNAIRE';
export const LESSONS = 'LESSONS';
export const SUBJECTS = 'SUBJECTS';
// AUTH
export const AUTHENTICATION = 'AUTHENTICATION';
export const EMAIL_VERIFICATION = 'EMAIL_VERIFICATION';
